// removed by extract-text-webpack-plugin
module.exports = {"simpleContainer":"index__simpleContainer___Hc_0H","tagsContainer":"index__tagsContainer___aCZN4","body":"index__body___3iNhR","auth-container":"index__auth-container___3kgYk","small":"index__small___2OCjv","large":"index__large___1_vmS","auth-container-title":"index__auth-container-title___3xlZ3","auth-container-subtitle":"index__auth-container-subtitle___3C1Jz","auth-container-actions":"index__auth-container-actions___2wjq3","auth-container-actions-top-right":"index__auth-container-actions-top-right___192eY","auth-container-spacer":"index__auth-container-spacer___1UWJg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/Containers/index.less
// module id = 273
// module chunks = 3